module.exports = __webpack_public_path__ + "img/lionparcel.9d6b92e5.png";